import React from "react";
import { useContext, useState, useEffect } from "react";
import 'leaflet/dist/leaflet.css';
import { Text, Button, Center, Container, Heading, Flex, Spacer, ButtonGroup, Box, TableContainer, Table, Thead, Tr, Th, Td, Tbody, Stack, Collapse, useDisclosure, SimpleGrid, Grid, GridItem, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Input, ModalFooter, Divider, useToast, Textarea, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter } from '@chakra-ui/react';
import { useNavigate } from "react-router-dom";
import { PlusSquareIcon, ChevronLeftIcon, DeleteIcon, EditIcon, TriangleDownIcon, NotAllowedIcon } from "@chakra-ui/icons";
import { NavigateIcon } from "../../icons/navigateicon";
import { BarCodeIcon } from "../../icons/barcodeicon";
import { TransferirIcon } from "../../icons/transferiricon";

import ContratoPDF from "./contratopdf";
import ProcuracaoPDF from "./procuracaopdf";
import RequerimentoPDF from "./requerimentopdf";
import PossePDF from "./possepdf";
import ResponsabilidadePDF from "./responsabilidadepdf";
import DistratoPDF from "./distratopdf";
import SigiloPDF from "./sigilopdf";

import { api } from "../../../services/api";
import Comentarios from "../../components/Comentario/comentarios";
import Fase from "../../components/Fase/fase";

import { AuthContext } from "../../contexts/auth";
import { ReurbContext } from "../../contexts/reurb";
import { MatriculaIcon } from "../../icons/matriculaicon";

const ExibirProcesso = () => {
  const { logout, user } = useContext(AuthContext);
  const { rem_id, nui_id, setNui_id, unid_id, setReq_id, setOcup_id, setEditar_processo, comentario_alterado, setComentario_alterado, rem_municipio } = useContext(ReurbContext);

  //Transitions  
  const { isOpen, onToggle } = useDisclosure();

  //Variáveis Chakra UI
  const navigate = useNavigate();
  const toast = useToast();
  const cancelRef = React.useRef();
  const { isOpen: isSituacaoOpen, onOpen: onSituacaoOpen, onClose: onSituacaoClose } = useDisclosure();
  const { isOpen: isCodigoOpen, onOpen: onCodigoOpen, onClose: onCodigoClose } = useDisclosure();
  const { isOpen: isMensagemOpen, onOpen: onMensagemOpen, onClose: onMensagemClose } = useDisclosure();
  const { isOpen: isDistratoOpen, onOpen: onDistratoOpen, onClose: onDistratoClose } = useDisclosure();
  const { isOpen: isExcluirOpen, onOpen: onExcluirOpen, onClose: onExcluirClose } = useDisclosure();
  const { isOpen: isMatriculaOpen, onOpen: onMatriculaOpen, onClose: onMatriculaClose } = useDisclosure();
  const { isOpen: isTransferirOpen, onOpen: onTransferirOpen, onClose: onTransferirClose } = useDisclosure();
  const { isOpen: isAlertaTransferirOpen, onOpen: onAlertaTransferirOpen, onClose: onAlertaTransferirClose } = useDisclosure();

  //Variáveis do processo
  const [unid_cod, setUnid_cod] = useState("");
  const [unid_areacomprovante, setUnid_areacomprovante] = useState("");
  const [reurb_modalidade, setReurb_modalidade] = useState("");
  const [reurb_situacao, setReurb_situacao] = useState("");
  const [reurb_fase, setReurb_fase] = useState("");
  const [localizacao, setLocalizacao] = useState("");
  const [reurb_instrumento, setReurb_instrumento] = useState("");
  const [reurb_objeto, setReurb_objeto] = useState("");
  const [reurb_matricula, setReurb_matricula] = useState("");
  const [matricula_emitida, setMatricula_emitida] = useState("");
  const [especial, setEspecial] = useState("");
  const [unid_historico, setUnid_historico] = useState("");

  //Qualificações
  const [quali_crf, setQuali_crf] = useState("");

  //Variáveis do núcleo
  const [nui_cod, setNui_cod] = useState("");
  const [nui_nome, setNui_nome] = useState("");

  //Lista de remessas
  const [lista_remessas, setLista_remessas] = useState([{ rem_id: 0, rem_municipio: '-', rem_remessa: '-', rem_titulo: '-', total: '-', ativos: '-', cancelados: '-', pendentes: '-', rem_fase: '-', rem_criado: '-' }]);

  //Transferir remessa
  const [trans_id, setTrans_id] = useState(0);
  const [trans_municipio, setTrans_municipio] = useState('-');
  const [trans_remessa, setTrans_remessa] = useState('-');

  //Lista de requerentes e ocupantes
  const [lista_requerentes, setLista_requerentes] = useState([{ id: 0, nome: '-', tipo: '-', beneficiario: '-', categoria: '-', representante: '-', contato: '-' }]);
  const [lista_ocupantes, setLista_ocupantes] = useState([{ id: 0, nome: '-', parentesco: '-' }]);

  //Variáveis alterar situação
  const [novasit, setNovasit] = useState("");
  const [motivo_situacao, setMotivo_situacao] = useState("");

  //Variáveis alterar código
  const [msg, setMsg] = useState("");
  const [novocod, setNovocod] = useState("");

  //Variável imprimir
  const [msg_imprimir, setMsg_imprimir] = useState("");

  //Distrato
  const [tipo_distrato, setTipo_distrato] = useState("");
  const [dis_valor, setDis_valor] = useState("");
  const [dis_qtd_parcelas, setDis_qtd_parcelas] = useState("");
  const [dis_valor_parcela, setDis_valor_parcela] = useState("");
  const [dis_dia, setDis_dia] = useState("");
  const [dis_comarca, setDis_comarca] = useState("");
  // Extorno: forma de devolução
  const [dis_forma_devolucao, setDis_forma_devolucao] = useState(""); // "pix" ou "carne"
  const [dis_pix_chave, setDis_pix_chave] = useState("");
  const [dis_pix_tipo, setDis_pix_tipo] = useState("");

  //Ler dados processo
  useEffect(() => {
    //Dados do Processo
    api.post('/processo/LerExibirProcesso.php', JSON.stringify({ unid_id }))
      .then(function (rp) {
        setUnid_cod(rp.data.unid_cod);
        setUnid_areacomprovante(rp.data.unid_areacomprovante);
        setReurb_modalidade(rp.data.reurb_modalidade);
        setReurb_situacao(rp.data.reurb_situacao);
        setNovasit(rp.data.reurb_situacao);
        setReurb_fase(rp.data.reurb_fase);
        setLocalizacao(rp.data.localizacao);
        setReurb_instrumento(rp.data.reurb_instrumento);
        setReurb_objeto(rp.data.reurb_objeto);
        setReurb_matricula(rp.data.reurb_matricula);
        setEspecial(rp.data.especial);
        setUnid_historico(rp.data.unid_historico);
        setQuali_crf(rp.data.quali_crf);
        setNui_id(rp.data.nui_id);
        setNui_cod(rp.data.nui_cod);
        setNui_nome(rp.data.nui_nome);

        setDis_valor(rp.data.dis_valor);
        setDis_qtd_parcelas(rp.data.dis_qtd_parcelas);
        setDis_valor_parcela(rp.data.dis_valor_parcela);
        setDis_dia(rp.data.dis_dia);
        setDis_comarca(rp.data.dis_comarca);
        setDis_forma_devolucao(rp.data.dis_forma_devolucao ?? "");
        setDis_pix_chave(rp.data.dis_pix_chave ?? "");
        setDis_pix_tipo(rp.data.dis_pix_tipo ?? "");

      })
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });

    //Lista de Requerentes
    api.post('/processo/LerListaRequerentes.php', JSON.stringify({ unid_id }))
      .then(function (rp) {
        setLista_requerentes(rp.data.lista_requerentes);
      })
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });

    //Lista de Ocupantes
    api.post('/processo/LerListaOcupantes.php', JSON.stringify({ unid_id }))
      .then(function (rp) {
        setLista_ocupantes(rp.data.lista_ocupantes);
      })
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });
  }, []);

  //Abrir mensagem imprimir
  useEffect(() => {
    //Exibir mensagem quando mudar
    if (msg_imprimir !== '') {
      onMensagemOpen();
    }
  }, [msg_imprimir]);

  //Salvar distrato
  async function salvarDistrato() {
    const data = {
      rem_id,
      unid_id,
      dis_valor,
      dis_qtd_parcelas,
      dis_valor_parcela,
      dis_dia,
      dis_comarca,
      dis_forma_devolucao,
      dis_pix_chave,
      dis_pix_tipo
    }
    await api.post('/processo/SalvarDistrato.php', JSON.stringify(data));
  }

  //Calcular valor da parcela do distrato
  function valorParcelaDistrato(valor_global, qtd_parcelas) {
    if (valor_global !== null && qtd_parcelas !== null) {
      valor_global = valor_global.replace(",", ".");
      qtd_parcelas = qtd_parcelas.replace(",", ".");
      if (parseFloat(valor_global) > 0 && parseFloat(qtd_parcelas) > 0) {
        const valor = String((parseFloat(valor_global) / parseFloat(qtd_parcelas)).toFixed(2));
        setDis_valor_parcela(valor.replace(".", ","));
      } else {
        setDis_valor_parcela("");
      }
    }

  }

  //Alterar situação
  async function alterarSituacao() {
    if (novasit !== reurb_situacao) {
      const data = {
        user,
        rem_id,
        unid_id,
        reurb_situacao,
        novasit,
        motivo_situacao
      }
      await api.post('/processo/AlterarSituacao.php', JSON.stringify(data))
        .then(function (rp) {
          if (rp.data.sucesso === true) {
            setReurb_situacao(novasit);
            onSituacaoClose();
            if (comentario_alterado === 0) {
              setComentario_alterado(1);
            } else {
              setComentario_alterado(0);
            }
          }
          return (toast({
            position: 'bottom-left', render: () => (<Box color='white' p={3} bg={rp.data.sucesso === true ? 'teal' : 'red'}>{rp.data.msg}</Box>),
          })
          );
        })
        .catch(function (error) {
          if (error.response.data === "EXPIRED") {
            logout();
          } else {
            console.log(error);
            return (toast({
              position: 'bottom-left', render: () => (<Box color='white' p={3} bg='red'>Erro: não foi possível registrar os dados!</Box>),
            })
            );
          }
        });
    }
  }

  //Alterar código
  function alterarCodigo() {
    if (novocod !== "") {
      const data = {
        user,
        rem_id,
        unid_id,
        unid_cod,
        novocod
      }
      api.post('/processo/AlterarCodigo.php', JSON.stringify(data))
        .then(function (rp) {
          setMsg(rp.data.msg);
          if (rp.data.msg === "") {
            setUnid_cod(novocod);
            setNovocod("");
            if (comentario_alterado === 0) {
              setComentario_alterado(1);
            } else {
              setComentario_alterado(0);
            }
            onCodigoClose();
          }
        })
        .catch(function (error) {
          if (error.response.data === "EXPIRED") {
            logout();
          } else {
            console.log(error);
          }
        });
    }
  }

  //Salvar matrícula
  async function salvarMatricula() {
    const data = {
      user,
      rem_id,
      unid_id,
      unid_cod,
      matricula_emitida
    }
    await api.post('/processo/SalvarMatricula.php', JSON.stringify(data))
      .then(function (rp) {
        if (rp.data.sucesso === true) {
          setReurb_matricula(rp.data.matricula);
          onMatriculaClose();
          if (comentario_alterado === 0) {
            setComentario_alterado(1);
          } else {
            setComentario_alterado(0);
          }
        }
        return (toast({
          position: 'bottom-left', render: () => (<Box color='white' p={3} bg={rp.data.sucesso === true ? 'teal' : 'red'}>{rp.data.msg}</Box>),
        })
        );
      })
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
          return (toast({
            position: 'bottom-left', render: () => (<Box color='white' p={3} bg='red'>Erro: não foi possível registrar os dados!</Box>),
          })
          );
        }
      });
  }

  //Novo Requerente
  async function novoRequerente(tipo) {
    const data = {
      rem_id,
      unid_id,
      tipo,
    }
    await api.post('/requerente/NovoRequerente.php', JSON.stringify(data))
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });

    //Atualizar lista de Requerentes
    await api.post('/processo/LerListaRequerentes.php', JSON.stringify({ unid_id }))
      .then(function (rp) {
        setLista_requerentes(rp.data.lista_requerentes);
      })
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });
  }

  //Novo Ocupante
  async function novoOcupante() {
    const data = {
      rem_id,
      unid_id
    }
    await api.post('/ocupante/NovoOcupante.php', JSON.stringify(data))
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });

    //Atualizar lista de Requerentes
    await api.post('/processo/LerListaOcupantes.php', JSON.stringify({ unid_id }))
      .then(function (rp) {
        setLista_ocupantes(rp.data.lista_ocupantes);
      })
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });
  }

  //Excluir processo
  async function excluirProcesso() {
    const data = {
      rem_id,
      unid_id
    }
    await api.post('/processo/ExcluirProcesso.php', JSON.stringify(data))
      .then(function (rp) {
        //Ir para processo
        navigate('/processos');
      })
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });
  }

  //Carregar Transferir
  async function lerTransferir() {
    const data = {
      rem_id
    }
    await api.post('/processo/LerListaRemessas.php', JSON.stringify(data))
      .then(function (rp) {
        setLista_remessas(rp.data.lista_remessas);
      })
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });
  }

  //Transferir Processo
  async function transferirProcesso() {
    const data = {
      rem_id,
      unid_id,
      trans_id
    }    
    await api.post('/processo/TransferirProcesso.php', JSON.stringify(data))
      .then(function (rp) {
        if (rp.data.sucesso === true) {
          goToProcessos();
        }
        return (toast({
          position: 'bottom-left', render: () => (<Box color='white' p={3} bg={rp.data.sucesso === true ? 'teal' : 'red'}>{rp.data.msg}</Box>),
        })
        );
      })
      .catch(function (error) {
        if (error.response.data === "EXPIRED") {
          logout();
        } else {
          console.log(error);
        }
      });
  }

  //Ir para lista de processos
  function goToProcessos() {
    navigate('/processos');
  }

  //Ir para requerente
  function irParaRequerente(id) {
    if (id > 0) {
      setReq_id(id);
      navigate('/requerente');
    }
  }

  //Ir para ocupante
  function irParaOcupante(id) {
    if (id > 0) {
      setOcup_id(id);
      navigate('/ocupante');
    }
  }

  //Ir para núcleo
  function irParaNucleo() {
    if (nui_id > 0) {
      navigate('/nucleo');
    } else {
      navigate('/nucleos');
    }
  }

  //Ir para modalidade
  function irParaModalidade() {
    navigate('/modalidade');
  }

  return (
    <div id="exibir_processo">
      <Container maxW={'95%'} mb={20}>

        <Flex direction='row' w={'100%'} h={'60px'} bg={'gray.200'}>
          <Center w={'100px'} h={'100%'} color={'gray.600'} cursor='pointer' _hover={{ color: 'teal' }} onClick={e => goToProcessos()}>
            <ChevronLeftIcon boxSize={12} />
          </Center>
          <Center>
            <Heading size={'md'} color={'gray.700'} ml={3} noOfLines={1}>Processo {unid_cod} - {reurb_modalidade} - {nui_cod}</Heading>
          </Center>
          <Spacer />
          <Center>
            <ButtonGroup gap='4' mr={4}>
              <Button colorScheme="teal" variant='outline' onClick={onToggle}>Imprimir <TriangleDownIcon ml={2} /></Button>
              <Button colorScheme="teal" variant='outline' onClick={e => setEditar_processo(1)}>Editar<EditIcon ml={2} /></Button>
              <Button colorScheme="teal" variant='outline' onClick={e => { lerTransferir(); onTransferirOpen() }}>Transferir<TransferirIcon ml={2} /></Button>
              <Button colorScheme="teal" variant='outline' onClick={e => onExcluirOpen()}>Excluir<DeleteIcon ml={2} /></Button>
            </ButtonGroup>
          </Center>
        </Flex>

        {/*COLLAPSE IMPRIMIR*/}
        <Collapse in={isOpen} animateOpacity >
          <Stack
            p={3}
            bg='gray.300'
            shadow='md'
            align={'center'}
            dir="column"
          >
            <ButtonGroup gap='4'>
              <Button colorScheme="gray" w={'200px'} h={'70px'} whiteSpace={'normal'} onClick={e => ContratoPDF(unid_id, setMsg_imprimir, 'open')}>Contrato</Button>
              <Button colorScheme="gray" w={'200px'} h={'70px'} whiteSpace={'normal'} onClick={e => ProcuracaoPDF(unid_id, setMsg_imprimir, 'open')}>Procuração</Button>
              <Button colorScheme="gray" w={'200px'} h={'70px'} whiteSpace={'normal'} onClick={e => RequerimentoPDF(unid_id, setMsg_imprimir, 'open')}>Requerimento</Button>
              <Button colorScheme="gray" w={'200px'} h={'70px'} whiteSpace={'normal'} onClick={e => PossePDF(unid_id, setMsg_imprimir)}>Declaração de Posse</Button>
              <Button colorScheme="gray" w={'200px'} h={'70px'} whiteSpace={'normal'} onClick={e => ResponsabilidadePDF(unid_id, setMsg_imprimir)}>Termo de Responsabilidade</Button>
            </ButtonGroup>
            <ButtonGroup gap='4' mt={4}>              
              <Button colorScheme="gray" w={'200px'} h={'70px'} whiteSpace={'normal'} onClick={e => DistratoPDF(unid_id, "basico", setMsg_imprimir)}>
                <Stack dir="row">
                  <Text>Distrato</Text>
                  <Text fontSize={'sm'} color={'gray.500'}>Básico</Text>
                </Stack>
              </Button>
              <Button colorScheme="gray" w={'200px'} h={'70px'} whiteSpace={'normal'} onClick={e => { setTipo_distrato('multa'); onDistratoOpen(); }}>
                <Stack dir="row">
                  <Text>Distrato</Text>
                  <Text fontSize={'sm'} color={'gray.500'}>Multa</Text>
                </Stack>
              </Button>
              <Button colorScheme="gray" w={'200px'} h={'70px'} whiteSpace={'normal'} onClick={e => { setTipo_distrato('extorno'); onDistratoOpen(); }}>
                <Stack dir="row">
                  <Text>Distrato</Text>
                  <Text fontSize={'sm'} color={'gray.500'}>Extorno</Text>
                </Stack>
              </Button>
              <Button colorScheme="gray" w={'200px'} h={'70px'} whiteSpace={'normal'} onClick={e => SigiloPDF(unid_id, setMsg_imprimir)}>Sigilo</Button>
            </ButtonGroup>
          </Stack>
        </Collapse>

        <Fase />

        <Grid
          mt={5}
          templateRows='repeat(1, 1fr)'
          templateColumns='repeat(12, 1fr)'
          gap={10}
        >
          <GridItem colSpan={5}>
            <SimpleGrid rows={4} spacing={5}>
              <Flex direction="column" background={'gray.200'} p={4}>
                <Heading as='h4' size='md' color={'gray.600'}>Imóvel</Heading>
                <Grid
                  templateRows='repeat(1, 1fr)'
                  templateColumns='repeat(12, 1fr)'
                  gap={10}
                >
                  <GridItem colSpan={7}>
                    <Text>Processo {unid_cod}</Text>
                    <Text color={reurb_objeto === "Objeto Não Informado" ? 'red' : 'black'}>{reurb_objeto}</Text>
                    <Text color={unid_areacomprovante === "Área Não Informada" ? 'red' : 'black'}>{unid_areacomprovante}</Text>
                    <Text display={reurb_matricula === "" ? 'block' : 'none'} color={'red'}>Matrícula Pendente</Text>
                    <Text display={reurb_matricula !== "" ? 'block' : 'none'}>{'Matrícula ' + reurb_matricula}</Text>
                  </GridItem>
                  <GridItem colSpan={5} textAlign={'right'} pr={2}>
                    <Button colorScheme="teal" variant='outline' mb={3} w={'150px'} onClick={onCodigoOpen}>Código<BarCodeIcon ml={2} /></Button>
                    <Button colorScheme="teal" variant='outline' w={'150px'} onClick={onMatriculaOpen}>Matrícula<MatriculaIcon ml={2} /></Button>
                  </GridItem>
                </Grid>
              </Flex>
              <Flex direction="column" background={'gray.200'} p={4}>
                <Heading as='h4' size='md' color={'gray.600'}>Localização</Heading>
                <Text color={localizacao === "Dados Incompletos" ? 'red' : 'black'} pr={'150px'}>{localizacao}</Text>
              </Flex>
              <Flex direction="column" background={'gray.200'} p={4}>
                <Heading as='h4' size='md' color={'gray.600'}>Reurb</Heading>
                <Grid
                  templateRows='repeat(1, 1fr)'
                  templateColumns='repeat(12, 1fr)'
                  gap={10}
                >
                  <GridItem colSpan={7}>
                    <Text display={reurb_situacao === "Situação Não Informada" ? 'block' : 'none'} color={'red'}>{reurb_situacao}</Text>
                    <Text display={reurb_situacao === "Situação Não Informada" ? 'none' : 'block'}>{'Situação ' + reurb_situacao}</Text>
                    <Text color={reurb_fase === "Fase Não Informada" ? 'red' : 'black'}>{reurb_fase}</Text>
                    <Text color={reurb_modalidade === "Sem Modalidade" ? 'red' : 'black'}>{reurb_modalidade}</Text>
                    <Text color={reurb_instrumento === "Instrumento Não Informado" ? 'red' : 'black'}>{reurb_instrumento}</Text>
                  </GridItem>
                  <GridItem colSpan={5} textAlign={'right'} pr={2}>
                    <Button colorScheme="teal" variant='outline' mb={3} w={'150px'} onClick={onSituacaoOpen}>Situação<NotAllowedIcon ml={2} /></Button>
                    <Button colorScheme="teal" variant='outline' w={'150px'} onClick={e => irParaModalidade()}>Modalidade<NavigateIcon ml={2} /></Button>
                  </GridItem>
                </Grid>
              </Flex>
              <Flex direction="column" background={'gray.200'} p={4}>
                <Heading as='h4' size='md' color={'gray.600'}>Núcleo</Heading>
                <Grid
                  templateRows='repeat(1, 1fr)'
                  templateColumns='repeat(12, 1fr)'
                  gap={10}
                >
                  <GridItem colSpan={7}>
                    <Text display={nui_cod === "Sem Núcleo" ? 'block' : 'none'} color={nui_cod === "Sem Núcleo" ? 'red' : 'black'}>{nui_cod}</Text>
                    <Text display={nui_cod === "Sem Núcleo" ? 'none' : 'blcok'}>{nui_nome + " (" + nui_cod + ")"}</Text>
                  </GridItem>
                  <GridItem colSpan={5} textAlign={'right'} pr={2}>
                    <Button colorScheme="teal" variant='outline' w={'150px'} onClick={e => irParaNucleo()}>Núcleo<NavigateIcon ml={2} /></Button>
                  </GridItem>
                </Grid>
              </Flex>
            </SimpleGrid>
          </GridItem>
          <GridItem colSpan={7}>
            <Heading as='h4' size='md' mb={2} color={'gray.600'}>Requerentes</Heading>
            <TableContainer mt={4} mb={4}>
              <Table size='sm'>
                <Thead>
                  <Tr>
                    <Th borderBottomColor={'gray.300'} textAlign={'center'}>NOME</Th>
                    <Th borderBottomColor={'gray.300'} textAlign={'center'}>CATEGORIA</Th>
                    <Th borderBottomColor={'gray.300'} textAlign={'center'}>BENEFICIÁRIO</Th>
                    <Th borderBottomColor={'gray.300'} textAlign={'center'}>TIPO</Th>
                    <Th borderBottomColor={'gray.300'} textAlign={'center'}>REPRESENTANTE</Th>
                    <Th borderBottomColor={'gray.300'} textAlign={'center'}>CONTATO</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {lista_requerentes.map((item, i) => {
                    return (
                      <Tr key={i} cursor='pointer' _hover={{ bg: 'gray.200' }} onClick={e => irParaRequerente(item.id)}>
                        <Td borderBottomColor={'gray.300'} whiteSpace={'pre-wrap'} maxW={'200px'}>{item.nome}</Td>
                        <Td borderBottomColor={'gray.300'} textAlign={'center'}>{item.categoria}</Td>
                        <Td borderBottomColor={'gray.300'} textAlign={'center'}>{item.beneficiario}</Td>
                        <Td borderBottomColor={'gray.300'} textAlign={'center'}>{item.tipo}</Td>
                        <Td borderBottomColor={'gray.300'} textAlign={'center'}>{item.representante}</Td>
                        <Td borderBottomColor={'gray.300'} textAlign={'center'}>{item.telefone}</Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
            <Flex>
              <Spacer />
              <ButtonGroup gap='4'>
                <Button colorScheme="gray" variant='outline' onClick={e => novoRequerente('pj')}>Pessoa Jurídica<PlusSquareIcon ml={2} /></Button>
                <Button colorScheme="gray" variant='outline' onClick={e => novoRequerente('pf')}>Pessoa Física<PlusSquareIcon ml={2} /></Button>
              </ButtonGroup>
            </Flex>
            <Heading as='h4' size='md' mt={2} color={'gray.600'}>Ocupantes</Heading>
            <TableContainer mt={4} mb={4}>
              <Table size='sm'>
                <Thead>
                  <Tr>
                    <Th borderBottomColor={'gray.300'} textAlign={'center'}>NOME</Th>
                    <Th borderBottomColor={'gray.300'} textAlign={'center'}>PARENTESCO</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {lista_ocupantes.map((item, i) => {
                    return (
                      <Tr key={i} cursor='pointer' _hover={{ bg: 'gray.200' }} onClick={e => irParaOcupante(item.id)}>
                        <Td borderBottomColor={'gray.300'}>{item.nome}</Td>
                        <Td borderBottomColor={'gray.300'} textAlign={'center'}>{item.parentesco}</Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
            <Flex>
              <Spacer />
              <Button colorScheme="gray" variant='outline' onClick={e => novoOcupante()}>Ocupante<PlusSquareIcon ml={2} /></Button>
            </Flex>
          </GridItem>
        </Grid>

        <Divider borderColor={'gray.400'} orientation='horizontal' mt={4} mb={4} />
        <Heading as='h4' size='md' color={'gray.600'}>Descrição</Heading>
        <Text>{especial}</Text>
        <Text>{unid_historico}</Text>
        <Text display={unid_historico === "" && especial === "" ? 'block' : 'none'}>Sem Informação</Text>
        <Divider borderColor={'gray.400'} orientation='horizontal' mt={4} mb={4} />
        <Heading as='h4' size='md' color={'gray.600'}>Qualificação</Heading>
        <Text color={quali_crf === "Dados Incompletos" ? 'red' : 'black'}>{quali_crf}</Text>
        <Divider borderColor={'gray.400'} orientation='horizontal' mt={4} mb={4} />

        <Comentarios painel="processo" />

      </Container>

      {/*MODAL ALTERAR SITUAÇÃO*/}
      <Modal isOpen={isSituacaoOpen} onClose={onSituacaoClose} isCentered size='2xl'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign='center'>ALTERAR SITUAÇÃO DO PROCESSO</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <SimpleGrid rows={3} spacing={10} m={5}>
              <Box>
                <Center>
                  <Stack spacing={6} direction='row'>
                    <Button colorScheme={novasit === "Ativo" ? 'green' : 'blackAlpha'} w={'150px'} h={'50px'} onClick={e => setNovasit("Ativo")}>Ativo</Button>
                    <Button colorScheme={novasit === "Pendente" ? 'green' : 'blackAlpha'} w={'150px'} h={'50px'} onClick={e => setNovasit("Pendente")}><Text>Pendente</Text></Button>
                    <Button colorScheme={novasit === "Cancelado" ? 'green' : 'blackAlpha'} w={'150px'} h={'50px'} onClick={e => setNovasit("Cancelado")}><Text>Cancelado</Text></Button>
                  </Stack>
                </Center>
              </Box>
              <Box>
                <Center>
                  <Text display={reurb_situacao === novasit ? 'block' : 'none'}>A situação do processo {unid_cod} está definida como {reurb_situacao}.</Text>
                  <Text display={reurb_situacao === novasit ? 'none' : 'block'}>Tem certeza que deseja alterar a situação do processo {unid_cod} para {novasit}?</Text>
                </Center>
              </Box>
              <Box>
                <Textarea display={reurb_situacao === novasit ? 'none' : 'block'} borderColor={'gray'} w="100%" minRows={3} placeholder={'Informe o motivo da alteração da situação (obrigatório)'} value={motivo_situacao} onChange={e => setMotivo_situacao(e.target.value)} />
              </Box>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter>
            <Button display={reurb_situacao === novasit ? 'none' : 'block'} colorScheme="teal" variant='outline' onClick={e => alterarSituacao()}>Alterar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/*MODAL ALTERAR CÓDIGO*/}
      <Modal isOpen={isCodigoOpen} onClose={onCodigoClose} isCentered size='2xl'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign='center'>ALTERAR CÓDIGO DO PROCESSO</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack spacing={3} direction='column'>
              <Flex direction='row' justifyContent='center'>
                <SimpleGrid columns={2} spacing={10}>
                  <Stack spacing={1} direction='column'><Text>Código Atual</Text><Input borderColor={'gray'} textAlign={'center'} size='sm' value={unid_cod} readOnly /></Stack>
                  <Stack spacing={1} direction='column'><Text>Código Novo</Text><Input borderColor={'gray'} size='sm' value={novocod} onChange={e => setNovocod(e.target.value)} textAlign={'center'} /></Stack>
                </SimpleGrid>
              </Flex>
              <Flex direction='row' justifyContent='center'><Text color='red.500'>{msg}</Text></Flex>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" variant='outline' onClick={e => alterarCodigo()}>Alterar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/*ALERT MENSAGEM IMPRIMIR*/}
      <Modal closeOnEsc={false} closeOnOverlayClick={false} isOpen={isMensagemOpen} onClose={onMensagemClose} isCentered size='2xl'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Dados Faltantes</ModalHeader>
          <ModalBody>
            <Text>{msg_imprimir}</Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={e => { setMsg_imprimir(''); onMensagemClose(); }}>
              OK
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/*MODAL TRANSFERIR PROCESSO*/}
      <Modal isOpen={isTransferirOpen} onClose={onTransferirClose} isCentered size='6xl'>
        <ModalOverlay />
        <ModalContent bg='gray.100'>
          <ModalHeader textAlign='center' p={5}>
            TRANSFERIR PROCESSO
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>

            <Flex direction={'column'}>
              <Center borderColor={'gray.400'} borderWidth={'thin'} borderRadius={10} p={2} mb={2}>
                <Text textAlign='center'>Transferir o Processo {unid_cod} para a Remessa:</Text>
              </Center>
              <Box
                overflowX="auto"
                whiteSpace="nowrap"
                pb="17px"
                sx={'::-webkit-scrollbar'}
                px="32px"
                w='100%' bg="white" p='5px' height='400px'>
                <TableContainer m={1} >
                  <Table size='sm'>
                    <Thead>
                      <Tr>
                        <Th textAlign={'center'} w={'15%'}>REMESSA</Th>
                        <Th textAlign={'center'} w={'30%'}>TÍTULO</Th>
                        <Th textAlign={'center'} w={'5%'}>TOTAL</Th>
                        <Th textAlign={'center'} w={'5%'}>ATIVOS</Th>
                        <Th textAlign={'center'} w={'5%'}>CANCELADOS</Th>
                        <Th textAlign={'center'} w={'5%'}>PENDENTES</Th>
                        <Th textAlign={'center'} w={'20%'}>FASE</Th>
                        <Th textAlign={'center'} w={'10%'}>DATA DE CRIAÇÃO</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {lista_remessas.map((item, i) => {
                        if (item.rem_id !== rem_id) {
                          return (
                            <Tr key={i} cursor={'pointer'} _hover={{ bg: 'gray.200' }} onClick={e => {setTrans_id(item.rem_id); setTrans_municipio(item.rem_municipio); setTrans_remessa(item.rem_remessa); onAlertaTransferirOpen()}}>
                              <Td>{item.rem_municipio} {item.rem_remessa}</Td>
                              <Td>{item.rem_titulo}</Td>
                              <Td textAlign={'center'}>{item.total}</Td>
                              <Td textAlign={'center'}>{item.ativos}</Td>
                              <Td textAlign={'center'}>{item.cancelados}</Td>
                              <Td textAlign={'center'}>{item.pendentes}</Td>
                              <Td textAlign={'center'}>{item.rem_fase}</Td>
                              <Td textAlign={'center'}>{item.rem_criado}</Td>
                            </Tr>
                          )
                        }
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            </Flex>

          </ModalBody>
        </ModalContent>
      </Modal>

      {/*MODAL ALERTA TRANSFERIR*/}
      <AlertDialog isOpen={isAlertaTransferirOpen} leastDestructiveRef={cancelRef.current} onClose={onAlertaTransferirClose} isCentered size='2xl'>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Transferir Processo
            </AlertDialogHeader>

            <AlertDialogBody>
              Tem certeza que deseja transferir o Processo {unid_cod} para a Remessa {trans_municipio} {trans_remessa}?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef.current} onClick={onAlertaTransferirClose}>
                Cancelar
              </Button>
              <Button colorScheme='orange' onClick={() => { transferirProcesso(); onAlertaTransferirClose();}} ml={3}>
                Transferir
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/*MODAL DISTRATO*/}
      <Modal isOpen={isDistratoOpen} onClose={onDistratoClose} isCentered size='3xl'>
        <ModalOverlay bg='blackAlpha.400' backdropFilter='blur(4px)' />
        <ModalContent borderRadius='xl' overflow='hidden' boxShadow='2xl'>

          {/* Cabeçalho colorido */}
          <Box bg={'teal.600'} px={8} py={5}>
            <Text fontSize='xs' fontWeight='700' letterSpacing='widest' color='whiteAlpha.700' textTransform='uppercase' mb={1}>
              {tipo_distrato === 'multa' ? 'Distrato' : 'Distrato'}
            </Text>
            <Text fontSize='xl' fontWeight='700' color='white' lineHeight='1.2'>
              {tipo_distrato === 'multa' ? 'Com Cobrança de Multa' : 'Com Extorno de Valor'}
            </Text>
            <ModalCloseButton color='whiteAlpha.800' top={4} right={4} _hover={{ color: 'white', bg: 'whiteAlpha.200' }} />
          </Box>

          <ModalBody px={8} py={7} bg='white'>

            {/* Seção: Valores */}
            <Text fontSize='xs' fontWeight='700' letterSpacing='wider' color='gray.400' textTransform='uppercase' mb={4}>
              Valores do Contrato
            </Text>
            <Grid templateColumns='repeat(3, 1fr)' gap={5} mb={6}>
              <Box>
                <Text fontSize='xs' fontWeight='600' color='gray.500' mb={1}>Valor Global (R$)</Text>
                <Input
                  borderColor='gray.200' borderRadius='lg' size='md' bg='gray.50'
                  maxLength={10} value={dis_valor}
                  _focus={{ borderColor: 'teal.400', bg: 'white', boxShadow: '0 0 0 1px teal' }}
                  onChange={e => { setDis_valor(e.target.value); valorParcelaDistrato(e.target.value, dis_qtd_parcelas); }}
                />
              </Box>
              <Box>
                <Text fontSize='xs' fontWeight='600' color='gray.500' mb={1}>Número de Parcelas</Text>
                <Input
                  borderColor='gray.200' borderRadius='lg' size='md' bg='gray.50'
                  maxLength={5} value={dis_qtd_parcelas}
                  _focus={{ borderColor: 'teal.400', bg: 'white', boxShadow: '0 0 0 1px teal' }}
                  onChange={e => { setDis_qtd_parcelas(e.target.value); valorParcelaDistrato(dis_valor, e.target.value); }}
                />
              </Box>
              <Box>
                <Text fontSize='xs' fontWeight='600' color='gray.500' mb={1}>Valor da Parcela (R$)</Text>
                <Input
                  borderColor='gray.200' borderRadius='lg' size='md' bg='gray.100'
                  color='gray.500' value={dis_valor_parcela} readOnly cursor='not-allowed'
                  _focus={{ boxShadow: 'none' }}
                />
              </Box>
            </Grid>

            {/* Seção: Informações Complementares */}
            <Text fontSize='xs' fontWeight='700' letterSpacing='wider' color='gray.400' textTransform='uppercase' mb={4}>
              Informações Complementares
            </Text>
            <Grid templateColumns='1fr 2fr' gap={5} mb={6}>
              <Box>
                <Text fontSize='xs' fontWeight='600' color='gray.500' mb={1}>Dia do Vencimento</Text>
                <Input
                  borderColor='gray.200' borderRadius='lg' size='md' bg='gray.50'
                  maxLength={3} value={dis_dia}
                  _focus={{ borderColor: 'teal.400', bg: 'white', boxShadow: '0 0 0 1px teal' }}
                  onChange={e => setDis_dia(e.target.value)}
                />
              </Box>
              <Box>
                <Text fontSize='xs' fontWeight='600' color='gray.500' mb={1}>Comarca do Foro</Text>
                <Input
                  borderColor='gray.200' borderRadius='lg' size='md' bg='gray.50'
                  maxLength={100} value={dis_comarca}
                  _focus={{ borderColor: 'teal.400', bg: 'white', boxShadow: '0 0 0 1px teal' }}
                  onChange={e => setDis_comarca(e.target.value)}
                />
              </Box>
            </Grid>

            {/* Seção exclusiva: Forma de Devolução (apenas Extorno) */}
            {tipo_distrato === 'extorno' && (
              <Box>
                <Divider borderColor='gray.100' mb={6} />
                <Text fontSize='xs' fontWeight='700' letterSpacing='wider' color='gray.400' textTransform='uppercase' mb={4}>
                  Forma de Devolução
                </Text>

                {/* Cartões de seleção PIX / Carnê */}
                <Grid templateColumns='1fr 1fr' gap={4} mb={dis_forma_devolucao === 'pix' ? 6 : 0}>
                  {/* Cartão PIX */}
                  <Box
                    border='2px solid'
                    borderColor={dis_forma_devolucao === 'pix' ? 'teal.500' : 'gray.200'}
                    borderRadius='xl' p={4} cursor='pointer' transition='all 0.15s'
                    bg={dis_forma_devolucao === 'pix' ? 'teal.50' : 'gray.50'}
                    _hover={{ borderColor: 'teal.400', bg: 'teal.50' }}
                    onClick={() => setDis_forma_devolucao('pix')}
                  >
                    <Flex align='center' gap={3}>
                      <Center
                        w='36px' h='36px' borderRadius='lg'
                        bg={dis_forma_devolucao === 'pix' ? 'teal.500' : 'gray.200'}
                        transition='all 0.15s'
                      >
                        <Text fontSize='lg'>⚡</Text>
                      </Center>
                      <Box>
                        <Text fontWeight='700' fontSize='sm' color={dis_forma_devolucao === 'pix' ? 'teal.700' : 'gray.600'}>PIX</Text>
                        <Text fontSize='xs' color='gray.400'>Transferência instantânea</Text>
                      </Box>
                    </Flex>
                  </Box>

                  {/* Cartão Carnê */}
                  <Box
                    border='2px solid'
                    borderColor={dis_forma_devolucao === 'carne' ? 'teal.500' : 'gray.200'}
                    borderRadius='xl' p={4} cursor='pointer' transition='all 0.15s'
                    bg={dis_forma_devolucao === 'carne' ? 'teal.50' : 'gray.50'}
                    _hover={{ borderColor: 'teal.400', bg: 'teal.50' }}
                    onClick={() => setDis_forma_devolucao('carne')}
                  >
                    <Flex align='center' gap={3}>
                      <Center
                        w='36px' h='36px' borderRadius='lg'
                        bg={dis_forma_devolucao === 'carne' ? 'teal.500' : 'gray.200'}
                        transition='all 0.15s'
                      >
                        <Text fontSize='lg'>🧾</Text>
                      </Center>
                      <Box>
                        <Text fontWeight='700' fontSize='sm' color={dis_forma_devolucao === 'carne' ? 'teal.700' : 'gray.600'}>Carnê</Text>
                        <Text fontSize='xs' color='gray.400'>Pagamento em parcelas</Text>
                      </Box>
                    </Flex>
                  </Box>
                </Grid>

                {/* Campos adicionais PIX */}
                {dis_forma_devolucao === 'pix' && (
                  <Box bg='teal.50' borderRadius='xl' p={5} border='1px solid' borderColor='teal.100'>
                    <Grid templateColumns='1fr 1fr' gap={5} mb={4}>
                      <Box>
                        <Text fontSize='xs' fontWeight='600' color='teal.700' mb={1}>Chave PIX</Text>
                        <Input
                          bg='white' borderColor='teal.200' borderRadius='lg' size='md'
                          maxLength={200} value={dis_pix_chave}
                          _focus={{ borderColor: 'teal.500', boxShadow: '0 0 0 1px teal' }}
                          placeholder='Informe a chave PIX'
                          onChange={e => setDis_pix_chave(e.target.value)}
                        />
                      </Box>
                      <Box>
                        <Text fontSize='xs' fontWeight='600' color='teal.700' mb={2}>Tipo da Chave</Text>
                        <Flex gap={2} flexWrap='wrap'>
                          {['CPF', 'CNPJ', 'e-mail', 'telefone', 'chave aleatória'].map(tipo => (
                            <Box
                              key={tipo}
                              as='button'
                              px={3} py={1} borderRadius='full' fontSize='xs' fontWeight='600'
                              border='1.5px solid'
                              borderColor={dis_pix_tipo === tipo ? 'teal.500' : 'teal.200'}
                              bg={dis_pix_tipo === tipo ? 'teal.500' : 'white'}
                              color={dis_pix_tipo === tipo ? 'white' : 'teal.600'}
                              cursor='pointer' transition='all 0.1s'
                              _hover={{ bg: dis_pix_tipo === tipo ? 'teal.600' : 'teal.50' }}
                              onClick={() => setDis_pix_tipo(tipo)}
                            >
                              {tipo}
                            </Box>
                          ))}
                        </Flex>
                      </Box>
                    </Grid>
                  </Box>
                )}
              </Box>
            )}

          </ModalBody>

          {/* Rodapé */}
          <Flex
            px={8} py={5} justify='flex-end' align='center'
            bg='gray.50' borderTop='1px solid' borderColor='gray.100'
          >
            <Button
              variant='ghost' color='gray.500' mr={3} borderRadius='lg'
              _hover={{ bg: 'gray.100' }}
              onClick={onDistratoClose}
            >
              Cancelar
            </Button>
            <Button
              bg={'teal.600'}
              color='white' borderRadius='lg' px={8} fontWeight='600'
              _hover={{ bg: 'teal.700' }}
              _active={{ bg: 'teal.800' }}
              onClick={() => { salvarDistrato(); DistratoPDF(unid_id, tipo_distrato, setMsg_imprimir, dis_forma_devolucao, dis_pix_chave, dis_pix_tipo); }}
            >
              Gerar PDF
            </Button>
          </Flex>

        </ModalContent>
      </Modal>

      {/*MODAL MATRÍCULA*/}
      <Modal isOpen={isMatriculaOpen} onClose={onMatriculaClose} isCentered size='2xl'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign='center'>MATRÍCULA EMITIDA</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Center m={5}>
              <Stack spacing={3} direction='row'><Text whiteSpace='nowrap' fontSize={'lg'} mt={2}>Número da Matrícula</Text><Input autoComplete="no" borderColor={'gray'} size='lg' maxW={'300px'} value={matricula_emitida} onChange={e => setMatricula_emitida(e.target.value)} /></Stack>
            </Center>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" variant='outline' onClick={e => salvarMatricula()}>Concluir</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/*MODAL EXCLUIR*/}
      <AlertDialog isOpen={isExcluirOpen} leastDestructiveRef={cancelRef.current} onClose={onExcluirClose} isCentered>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Excluir Processo
            </AlertDialogHeader>

            <AlertDialogBody>
              Tem certeza que deseja excluir o processo {unid_cod}?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef.current} onClick={onExcluirClose}>
                Cancelar
              </Button>
              <Button colorScheme='red' onClick={() => { excluirProcesso(); onExcluirClose(); }} ml={3}>
                Excluir
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

    </div>
  );
}

export default ExibirProcesso;